if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButtonWasDisabled = false;
      }

      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;

        const variantInput = this.form.querySelector('[name=id]');
        if (variantInput) variantInput.disabled = false;

        this.submitButton = this.querySelector('[type="submit"]');
        this.spinner = this.submitButton ? this.submitButton.querySelector('.loading__spinner') : null;
        this.submitButtonWasDisabled = this.submitButton ? this.submitButton.hasAttribute('disabled') : false;

        if (this.submitButton) {
          this.submitButton.addEventListener('click', () => {
            if (!this.submitButton.classList.contains('loading')) {
              this.submitButton.classList.add('loading');
              if (this.spinner) this.spinner.classList.remove('hidden');
            }
          });
        }

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }

        if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.disabled = true;
          this.submitButton.classList.add('loading');
        }

        if (this.spinner) this.spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const updateCartIconBubble = (html) => {
          var cartBubbleEl = document.getElementById('cart-icon-bubble');
          if (!cartBubbleEl) return;
          var parser = new DOMParser();
          var bubbleDoc = parser.parseFromString(html, 'text/html');
          var bubbleContent = bubbleDoc.querySelector('.shopify-section') || bubbleDoc.getElementById('cart-icon-bubble') || bubbleDoc.body.firstElementChild;

          if (bubbleContent) {
            cartBubbleEl.innerHTML = bubbleContent.innerHTML;
          } else {
            cartBubbleEl.innerHTML = html;
          }
        };

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span')?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    if (response.sections && response.sections['cart-icon-bubble']) {
                      updateCartIconBubble(response.sections['cart-icon-bubble']);
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              if (response.sections && response.sections['cart-icon-bubble']) {
                updateCartIconBubble(response.sections['cart-icon-bubble']);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
              if (this.submitButton) {
              this.submitButton.classList.remove('loading');
              if (!this.submitButtonWasDisabled) this.submitButton.disabled = false;
              if (!this.error && !this.submitButton.hasAttribute('disabled')) {
                this.submitButton.removeAttribute('aria-disabled');
              }
            }

            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (this.spinner) this.spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
